import { useMemo } from 'react';
import Heading from '@components/Heading/Heading';
import InspirationSlider from '@components/InspirationSlider/InspirationSlider';
import styles from '@components/SliderLinkedItems/SliderLinkedItems.styles';
import { ICmsDocument } from '@features/cms/typescript';
import { useResponsive } from '@features/responsive';
import SingleArticle from '@components/SingleArticle/SingleArticle';
import { IProductObject } from '@features/categories';
import ProductCard from '@components/ProductCardNew/ProductCard';
type PropsType = {
  title: string;
  products?: IProductObject[];
  articles?: ICmsDocument[];
};
const SliderLinkedItems = ({
  title,
  products = undefined,
  articles = undefined
}: PropsType) => {
  const {
    isWiderThanTablet
  } = useResponsive();
  const getSpace = () => isWiderThanTablet ? 24 : 4;
  const renderSlides = useMemo(() => () => {
    if (products) return products.map(product => <div key={product.id} sx={styles.productBox}>
            <ProductCard product={product} isSlider />
          </div>);
    if (articles) return articles.map(article => <SingleArticle key={article.id} article={article} />);
    return null;
  }, [products, articles]);
  return <section sx={styles.linkedSection(!!articles)}>
      <Heading h={2} headingType={2} mobile pb={[48, 48, 48, 40]}>
        {title}
      </Heading>
      <InspirationSlider withScrollBar equalHeightSlides={!!products} spaceBetween={getSpace()} slidesPerView="auto" withOffset isArticles={!!articles}>
        {renderSlides()}
      </InspirationSlider>
    </section>;
};
export default SliderLinkedItems;